const db = "reminders";

export const newReminder = (data) => {
  const added = "REMINDER_ADDED";
  const adding = "REMINDER_ADDING";
  const ERROR = "REMINDER_ADD_ERROR";
  const clearStatus = "REMINDER_ADD_CLEAR_STATUS";
  return (dispatch, not, { getFirebase, getFirestore }) => {
    dispatch({ type: adding });
    const today = new Date();

    const firestore = getFirestore();
    const firebase = getFirebase();
    const batch = firestore.batch();
    // Remove This Line Before Deployment
    // firebase.functions().useEmulator("localhost", 5001);

    const currentTime = firebase.firestore.Timestamp.fromDate(today);
    const remindersRef = firestore.collection(db).doc(data.id);
    const sendReminderEmail = firebase
      .functions()
      .httpsCallable("sendReminderEmail");
    const toFirestore = {
      ...data,
      modifiedAt: currentTime,
    };
    batch.set(remindersRef, toFirestore, { merge: true });
    batch
      .commit()
      .then(() => {
        sendReminderEmail(data)
          .then(() => {
            dispatch({ type: added });
            dispatch({ type: clearStatus });
          })
          .catch((e) => {
            dispatch({
              type: ERROR,
              err: "ERROR : Unknown Error While Sending Mail",
            });
          });
      })
      .catch((e) => {
        dispatch({ type: ERROR, err: e });
      });
  };
};

export const deleteReminder = (id) => {
  return (dispatch, not, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const remindersRef = firestore.collection(db).doc(id);
    remindersRef.delete();
  };
};
